var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"provider-list"}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("Providers")])],1),_c('v-divider'),_c('v-container',{attrs:{"fluid":""}},[_vm._v(" providers will go here ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }